export const addresses = {
  storeAddress: "0x74Df809b1dfC099E8cdBc98f6a8D1F5c2C3f66f8",
  tokenAddress: "0x3f9A1B67F3a3548e0ea5c9eaf43A402d12b6a273",
};
